import React from "react";
import { Check } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Button } from "./Button";
const PRODUCT_IMAGE_URL = "https://cdn.magicpatterns.com/uploads/hmVM8txqysKpPWQXeC4oe2/MOCK_UP_SIN_FONDO.png";
const trustIndicators = ["Acceso inmediato", "Uso comercial incluido", "Garantía de 7 días"];
export function Hero() {
  const prefersReducedMotion = useReducedMotion();
  const shouldReduceMotion = Boolean(prefersReducedMotion);
  const handleOfferClick = () => {
    const offerSection = document.querySelector<HTMLElement>("#card");
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: shouldReduceMotion ? "auto" : "smooth",
        block: "start"
      });
      window.history.pushState(null, "", "#card");
      return;
    }
    window.location.hash = "card";
  };
  return <section aria-labelledby="hero-heading" className="relative isolate w-full overflow-hidden bg-[#090B0D] text-[#F8F8F6]" data-id="element-94" data-mp="3d2tpxe128sgn">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 -z-20 bg-[linear-gradient(125deg,#090B0D_0%,#0d1013_48%,#111519_100%)]" data-id="element-95" data-mp="3j8iwsycd6eu6" />
      <div aria-hidden="true" className="pointer-events-none absolute -right-[18%] top-[4%] -z-10 h-[88%] w-[75%] rounded-full bg-[radial-gradient(circle,rgba(242,184,75,0.15)_0%,rgba(217,138,36,0.06)_38%,rgba(9,11,13,0)_72%)]" data-id="element-96" data-mp="3o6aru18b2h2l" />
      <div aria-hidden="true" className="pointer-events-none absolute inset-x-0 bottom-0 h-px bg-[linear-gradient(90deg,transparent,rgba(242,184,75,0.3),transparent)]" data-id="element-97" data-mp="3ebioshvyf20f" />

      <div className="mx-auto flex min-h-[calc(100svh-41px)] max-w-[1440px] items-center px-5 py-14 sm:px-8 sm:py-16 lg:px-12 lg:py-20 xl:px-20 2xl:px-24" data-id="element-98" data-mp="35aau09sncjb3">
        <div className="relative z-10 flex w-full flex-col items-start" data-id="element-99" data-mp="2viojkfo4uo9e">
          <motion.p initial={shouldReduceMotion ? false : {
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.55,
          ease: "easeOut"
        }} className="mb-5 text-[11px] font-semibold uppercase tracking-[0.22em] text-[#F2B84B] sm:text-xs" style={{
          textAlign: "center"
        }} data-id="element-100" data-mp="2vglm5aknhsun">
            Biblioteca profesional · +1.000 GIFs
          </motion.p>

          <motion.h1 id="hero-heading" initial={shouldReduceMotion ? false : {
          opacity: 0,
          y: 14
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.72,
          delay: 0.06,
          ease: [0.22, 1, 0.36, 1]
        }} className="max-w-[940px] text-[2.4rem] font-bold leading-[1.03] tracking-[-0.045em] text-[#F8F8F6] sm:text-[3.25rem] lg:text-[3.75rem] xl:text-[4rem]" style={{
          textAlign: "center"
        }} data-id="element-101" data-mp="ibp0ush8d0y2">
            Tus alumnos siguen ejecutando mal{" "}
            <span className="text-[#F2B84B]" data-id="element-102" data-mp="x0uywd4c0l4d">incluso después de la explicación?</span>
          </motion.h1>

          <motion.div initial={shouldReduceMotion ? false : {
          opacity: 0,
          scale: 0.975
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.9,
          delay: 0.12,
          ease: [0.22, 1, 0.36, 1]
        }} className="relative z-0 mx-auto mt-8 flex w-full max-w-[900px] items-center justify-center" data-id="element-103" data-mp="3lqug7stmcf76">
            <div aria-hidden="true" className="pointer-events-none absolute left-1/2 top-1/2 -z-10 h-[62%] w-[74%] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[radial-gradient(circle,rgba(242,184,75,0.16),rgba(217,138,36,0.05)_45%,transparent_72%)]" data-id="element-104" data-mp="268fypstcm4hv" />
            <img src={PRODUCT_IMAGE_URL} alt="Mockup oficial de la biblioteca Recursos Fitness Pro con más de 1.000 GIFs de musculación en múltiples dispositivos" className="h-auto w-full object-contain drop-shadow-[0_28px_36px_rgba(0,0,0,0.42)] sm:w-[94%]" loading="eager" fetchPriority="high" draggable={false} data-id="element-105" data-mp="2kydryn64xkdx" />
          </motion.div>

          <motion.div initial={shouldReduceMotion ? false : {
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.68,
          delay: 0.16,
          ease: [0.22, 1, 0.36, 1]
        }} className="mt-6 w-full" data-id="element-106" data-mp="uo0ug38miwqn">
            <p className="max-w-[610px] text-base leading-7 text-[#B7BBC0] sm:text-lg sm:leading-8" data-id="element-107" data-mp="3vhfdq50udxi6">
              Usa una biblioteca profesional de{" "}
              <strong className="font-semibold text-[#F8F8F6]" data-id="element-108" data-mp="99xirg8shlgz">+1.000 GIFs de ejercicios</strong>{" "}
              lista para enviar por WhatsApp o cualquier otra aplicación de mensajería.
            </p>

            <motion.div className="relative mt-8 w-full rounded-full sm:w-fit" whileHover={shouldReduceMotion ? undefined : {
            scale: 1.02,
            y: -2
          }} whileTap={shouldReduceMotion ? undefined : {
            scale: 0.98,
            y: 0
          }} transition={{
            duration: 0.25,
            ease: [0.22, 1, 0.36, 1]
          }} data-id="element-109" data-mp="3crz1ikfsoglx">
              <motion.span aria-hidden="true" className="pointer-events-none absolute -inset-3 rounded-full bg-[#F2B84B]/25 blur-xl" animate={shouldReduceMotion ? {
              opacity: 0.38,
              scale: 1
            } : {
              opacity: [0.3, 0.62, 0.3],
              scale: [0.98, 1.04, 0.98]
            }} transition={shouldReduceMotion ? {
              duration: 0
            } : {
              duration: 3,
              ease: "easeInOut",
              repeat: Infinity
            }} data-id="element-110" data-mp="2u0y1dt2xuf0s" />
              <span aria-hidden="true" className="pointer-events-none absolute -inset-[5px] rounded-full border border-[#F2B84B]/35 shadow-[0_0_18px_rgba(242,184,75,0.18)]" data-id="element-111" data-mp="1s8vhu8lxoxaj" />
              <Button type="button" size="lg" onClick={handleOfferClick} className="relative h-14 w-full rounded-full border border-[#F8D788]/70 bg-[#F2B84B] px-7 text-[15px] font-bold text-[#101010] shadow-[0_7px_18px_rgba(217,138,36,0.24),0_0_22px_rgba(242,184,75,0.28),inset_0_1px_0_rgba(255,255,255,0.38)] transition-[background-color,box-shadow] duration-[250ms] ease-out hover:bg-[#F6C667] hover:shadow-[0_11px_24px_rgba(217,138,36,0.32),0_0_34px_rgba(242,184,75,0.48),inset_0_1px_0_rgba(255,255,255,0.45)] focus-visible:ring-[#F2B84B]/60 sm:w-auto sm:min-w-[245px]" data-id="element-112" data-mp="1j8gs8x1xsw18">
                Quiero acceder ahora →
              </Button>
            </motion.div>

            <ul aria-label="Beneficios de la compra" className="mt-5 grid w-full max-w-[640px] grid-cols-3 items-center gap-2 text-center text-[10px] text-[#B7BBC0] min-[390px]:text-[11px] sm:text-[13px]" data-id="element-113" data-mp="24pxx0trtznzc">
              {trustIndicators.map(indicator => <li key={indicator} className="flex items-center justify-center gap-1 sm:gap-1.5" data-id="element-114" data-mp="1qs9cjn1oeiut">
                  <Check aria-hidden="true" className="h-3.5 w-3.5 shrink-0 stroke-[2.5] text-[#F2B84B]" data-id="element-115" data-mp="1lsmy5aa42wkf" />
                  <span data-id="element-116" data-mp="1gubp31rn4q39">{indicator}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}